// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2IXXI","footer":"styles_footer__2Qnok","passCodeTooltip":"styles_passCodeTooltip__3gHpW"};